/* JOLI POT, fiches par occasion (modèle produit « occasion ») : barre de prix collante + suspension macramé en petit plus
   (assets/jp-occasion-panier.js, 23/10/2026). Réglages lus dans #jp-occasion-panier-cfg, écrit par snippets/jp-occasion-panier.liquid.
   Barre : .jp-barre-mob.jp-barre-occ (classe is-visible quand le vrai bouton d'ajout n'est pas à l'écran, suivie par jp-bon-decalage).
   Prix et livraison repris de la barre d'origine du configurateur (masquée sur ces fiches). Bouton : clique le vrai bouton d'ajout
   (le configurateur ajoute tout au panier en un envoi /cart/add.js puis ouvre le tiroir ou la page panier), sinon remonte à l'étape à compléter.
   Macramé : prix ajouté via window.jpPrixSupp, ligne ajoutée au panier via window.jpItemsSupp (crochets de assets/jp-configurateur.js),
   en chaînant ceux déjà posés (supplément prénom). */
(function () {
  var form = document.querySelector('form.jp-produit-form');
  if (!form) return;
  var cfgEl = document.getElementById('jp-occasion-panier-cfg'), C = {};
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var POS_T = C.posTaille || 0, POS_C = C.posCoupelle || 0, SUSP = C.susp || {}, BARRE = C.barre !== false;
  var TXT_BARRE = C.barreTitre || 'Votre Joli Pot', TXT_BOUTON = C.barreBouton || 'Ajouter au panier', PRIX0 = C.prix0 || '';
  var lisse = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  function bouton() { return form.querySelector('.ProductForm__AddToCart'); }
  function valeur(pos) { var r = pos ? form.querySelector('.SizeSwatch__Radio[data-option-position="' + pos + '"]:checked, .ColorSwatch__Radio[data-option-position="' + pos + '"]:checked') : null; return r ? r.value : ''; }
  function plusOuvert() { var p = form.querySelector('.product-form__item--checkboxes'); return document.documentElement.classList.contains('jp-pret') && !(p && p.classList.contains('jp-cache')); }

  /* ===== 2. Suspension macramé ===== */
  var bloc = document.getElementById('jp-macrame'), caseM = document.getElementById('jp-macrame-check'), courante = null;
  if (bloc && caseM) {
    var apres = null;
    [POS_C, POS_T].some(function (p) { var r = p ? form.querySelector('[data-option-position="' + p + '"]') : null; apres = r ? r.closest('.ProductForm__Option') : null; return !!apres; });
    if (apres && apres.parentNode) apres.parentNode.insertBefore(bloc, apres.nextSibling); else bloc.remove();
    var im = bloc.querySelector('.jp-macrame__img'), astuce = document.getElementById('jp-macrame-astuce');
    var ecrire = function (sel, t) { var el = bloc.querySelector(sel); if (el && el.textContent !== t) el.textContent = t; };
    var majMacrame = function () {
      if (!bloc.isConnected) return;
      var m = valeur(POS_T).match(/\d+/), s = m ? SUSP[m[0]] : null;
      var montrer = !!s && plusOuvert();
      if (s) {
        courante = s;
        ecrire('.jp-macrame__nom', s.nom);
        ecrire('.jp-macrame__collab', s.collab || '');
        ecrire('.jp-macrame__prix', '+' + s.prixTxt);
        if (s.image) { if (im.getAttribute('src') !== s.image) im.src = s.image; im.hidden = false; } else im.hidden = true;
      }
      if (bloc.hidden === montrer) bloc.hidden = !montrer;
      if (!s && caseM.checked) { caseM.checked = false; caseM.dispatchEvent(new Event('change', { bubbles: true })); }
      if (!s) courante = null;
      var a = !(caseM.checked && POS_C && /sans/i.test(valeur(POS_C)));
      if (astuce && astuce.hidden !== a) astuce.hidden = a;
    };
    var actif = function () { return !!(courante && caseM.checked && !bloc.hidden); };
    var prevP = window.jpPrixSupp, prevI = window.jpItemsSupp;
    window.jpPrixSupp = function () { var t = 0; if (typeof prevP === 'function') { try { t = prevP() || 0; } catch (e) {} } return t + (actif() ? courante.prix : 0); };
    window.jpItemsSupp = function (items, qte, props) {
      if (typeof prevI === 'function') { try { prevI(items, qte, props); } catch (e) {} }
      if (actif()) items.push({ id: courante.id, quantity: qte });
    };
    form.addEventListener('change', function (e) { if (e.target !== caseM) setTimeout(majMacrame, 0); else majMacrame(); });
    if (window.MutationObserver) {
      new MutationObserver(majMacrame).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      var p0 = form.querySelector('.product-form__item--checkboxes');
      if (p0) new MutationObserver(majMacrame).observe(p0, { attributes: true, attributeFilter: ['class'] });
    }
    majMacrame();
    window.addEventListener('load', majMacrame);
  }

  /* ===== 1. Barre de prix collante ===== */
  if (!BARRE) return;
  var bar = document.createElement('div');
  bar.className = 'jp-barre-mob jp-barre-occ';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', TXT_BARRE);
  bar.innerHTML = '<span class="jp-barre-mob__fil" hidden><i></i></span><div class="jp-barre-mob__prix"><small></small><strong aria-live="polite" aria-atomic="true"></strong><small class="jp-barre-mob__liv" hidden></small></div><button type="button" class="jp-barre-mob__btn"></button>';
  bar.querySelector('small').textContent = TXT_BARRE;
  var prixEl = bar.querySelector('strong'), btn = bar.querySelector('button'), livEl = bar.querySelector('.jp-barre-mob__liv'), filEl = bar.querySelector('.jp-barre-mob__fil');
  prixEl.textContent = PRIX0;
  btn.textContent = TXT_BOUTON;
  bar.inert = true;
  function poser() { if (!bar.isConnected) { document.body.appendChild(bar); document.documentElement.classList.add('jp-occ-barre'); } }
  if (document.body) poser(); else document.addEventListener('DOMContentLoaded', poser);

  function pret(bp) { return !!(bp && !bp.disabled && !bp.classList.contains('jp-cache') && bp.offsetParent !== null); }
  var vu = false, observe = null, raf = 0;
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (e) { vu = e[e.length - 1].isIntersecting; planifier(); }, { threshold: 0.2 }) : null;

  function maj() {
    raf = 0;
    var bp = bouton();
    if (io && bp && bp !== observe) { if (observe) io.unobserve(observe); io.observe(bp); observe = bp; }
    /* Prix : celui calculé par le configurateur (sa barre d'origine, masquée), sinon celui du bouton ou du titre */
    var src = document.querySelector('.jp-barre-mob:not(.jp-barre-occ)');
    var p = src && src.querySelector('strong') ? src.querySelector('strong').textContent : '';
    if (!p) { var b2 = bp && bp.querySelector('[data-money-convertible]'); p = b2 ? b2.textContent : ''; }
    if (!p) { var t2 = document.querySelector('.jp-produit-meta .ProductMeta__Price'); p = t2 ? t2.textContent : ''; }
    p = (p || '').trim();
    if (p && prixEl.textContent !== p) prixEl.textContent = p;
    /* Livraison offerte : ligne et filet repris de la barre du configurateur */
    if (src) {
      var l = src.querySelector('.jp-barre-mob__liv'), f = src.querySelector('.jp-barre-mob__fil');
      if (l) { if (livEl.textContent !== l.textContent) livEl.textContent = l.textContent; livEl.hidden = l.hidden; livEl.classList.toggle('is-ok', l.classList.contains('is-ok')); }
      if (f) { filEl.hidden = f.hidden; filEl.classList.toggle('is-ok', f.classList.contains('is-ok')); var fi = f.querySelector('i'); if (fi) filEl.querySelector('i').style.width = fi.style.width; }
    }
    var ok = pret(bp);
    if (ok) {
      var lib = (bp.querySelector('span') || bp).textContent.replace(/\s*[^\w\s]?\s*[0-9][0-9\s.,]* ?€.*$/, '').trim();
      btn.textContent = lib || TXT_BOUTON;
    } else if (btn.textContent !== TXT_BOUTON) btn.textContent = TXT_BOUTON;
    var visible = !!bp && !(ok && vu);
    if (bar.classList.contains('is-visible') !== visible) bar.classList.toggle('is-visible', visible);
    bar.inert = !visible;
  }
  function planifier() { if (!raf) raf = requestAnimationFrame(maj); }

  /* Étape à compléter : celle que le configurateur met en attente, sinon la première option non validée */
  function etapeManquante() {
    var a = form.querySelector('.ProductForm__Option.jp-attente');
    if (a && a.offsetParent !== null) return a;
    var l = [].filter.call(form.querySelectorAll('.ProductForm__Option'), function (b) {
      return b.querySelector('.SizeSwatch__Radio, .ColorSwatch__Radio') && b.style.display !== 'none' && b.offsetParent !== null && !b.dataset.jpFait;
    });
    return l[0] || form;
  }
  function allerA(el) {
    var y = el.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo({ top: Math.max(0, y), behavior: lisse ? 'smooth' : 'auto' });
    var r = el.querySelector && (el.querySelector('.SizeSwatch__Radio:checked, .ColorSwatch__Radio:checked') || el.querySelector('.SizeSwatch__Radio, .ColorSwatch__Radio'));
    setTimeout(function () { try { (r || el).focus({ preventScroll: true }); } catch (e) {} }, lisse ? 450 : 0);
    el.classList.add('jp-occ-rappel');
    setTimeout(function () { el.classList.remove('jp-occ-rappel'); }, 1800);
  }
  btn.addEventListener('click', function () {
    var bp = bouton();
    if (pret(bp)) { bp.click(); return; }
    allerA(etapeManquante());
  });

  form.addEventListener('change', function () { setTimeout(planifier, 260); });
  form.addEventListener('input', function () { setTimeout(planifier, 260); });
  form.addEventListener('click', function () { setTimeout(planifier, 260); });
  if (window.MutationObserver) {
    var mo = new MutationObserver(planifier);
    mo.observe(form, { attributes: true, attributeFilter: ['class', 'disabled', 'style'], childList: true, subtree: true, characterData: true });
    /* Barre d'origine du configurateur (prix, livraison) : suivie dès qu'elle existe */
    var suivie = null;
    var guetter = function () {
      var s = document.querySelector('.jp-barre-mob:not(.jp-barre-occ)');
      if (s && s !== suivie) { suivie = s; mo.observe(s, { childList: true, subtree: true, characterData: true, attributes: true }); planifier(); }
      return !!s;
    };
    if (!guetter() && document.body) new MutationObserver(function (m, o) { if (guetter()) o.disconnect(); }).observe(document.body, { childList: true });
    window.addEventListener('load', guetter);
  }
  window.addEventListener('resize', planifier, { passive: true });
  window.addEventListener('pageshow', planifier);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', planifier); else planifier();
  window.addEventListener('load', function () { planifier(); setTimeout(planifier, 800); });
})();
